import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  IconButton,
  Tooltip,
  Collapse,
} from '@mui/material';
import {
  Business as BusinessIcon,
  People as PeopleIcon,
  Science as ScienceIcon,
  Tune as TuneIcon,
  Inventory as InventoryIcon,
  Verified as VerifiedIcon,
  Close as CloseIcon,
  Send as SendIcon,
  Dashboard as DashboardIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  Architecture as ArchitectureIcon,
  Email as EmailIcon,
  List as ListIcon,
  Category as CategoryIcon,
  Assignment as AssignmentIcon,
  Description as DescriptionIcon,
  Folder as FolderIcon,
  ExpandLess,
  ExpandMore,
  Assessment as AssessmentIcon,
  Person,
  PersonPinCircleOutlined,
  Person2,
  CreditCard as PaymentIcon,
  Receipt as ReceiptIcon,
  Business as AccountBalanceIcon,
  RequestPage as RequestPageIcon,
  Analytics as AnalyticsIcon,
  InsertDriveFile as InvoiceIcon,
  Block as ExemptionIcon,
  Policy as GSTIcon,
  CheckCircle as ApprovalIcon,
  Search as SearchIcon
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';


const Sidebar = ({
  isMobile,
  onClose,
  autoSaveProgress = 0,
  activeStep = 0,
  onSectionClick = () => { },
  showDeclaration = false, // New prop to control Declaration visibility
  collapsed = false, // New prop to control collapsed state
  onCollapseToggle = () => { } // New prop to handle collapse toggle
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [applicationStage, setApplicationStage] = useState(null);
  const [userTypeId, setUserTypeId] = useState(null);
  const [openDropdowns, setOpenDropdowns] = useState({});

  // Get application stage from API
  const getApplicationStage = async (appId) => {
    try {
      if (!appId) return;

      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000/api'}/laboratory/application-stage/${appId}`);
      const result = await response.json();

      if (result.success) {
        setApplicationStage(result.stage);
      } else {
        setApplicationStage('1'); // Default to 1
      }
    } catch (error) {
      console.error('Error fetching application stage:', error);
      setApplicationStage('1'); // Default to 1
    }
  };

  // Get application stage and user type
  useEffect(() => {
    const appId = localStorage.getItem('appId') || localStorage.getItem('orgId');
    const userType = localStorage.getItem('userTypeId') || '1';

    setUserTypeId(userType);

    if (appId) {
      getApplicationStage(appId);
    }
  }, []);

  // Check if current user is a sub-user
  const isSubUser = localStorage.getItem('isSubUser') === 'true';

  console.log('🔍 Sidebar - isSubUser check:', {
    isSubUser,
    isSubUserValue: localStorage.getItem('isSubUser'),
    userTypeId,
    disciplineId: localStorage.getItem('disciplineId')
  });

  // Check if user should see final submit and dashboard options
  const shouldShowFinalSubmitOptions = ((applicationStage === '18' || applicationStage === '18b') && userTypeId === '4');
  const shouldShowFinaluserSubmitOptions = (applicationStage === '18a');

  const MenuItems = [
    {
      title: 'Dashboard',
      icon: DashboardIcon,
      path: '/main/accounts/dashboard',
      completed: false,
      id: 'dashboard'
    },
    {
      title: 'Payments',
      icon: PaymentIcon,
      isDropdown: true,
      id: 'payments',
      completed: false,
      subItems: [
        {
          title: 'Payment Details',
          icon: DescriptionIcon,
          path: '/main/accounts/payment-details',
          completed: false,
          id: 'payment-details'
        },
        {
          title: 'Approval Request',
          icon: ApprovalIcon,
          path: '/main/accounts/approvalRequest',
          completed: false,
          id: 'approval-request'
        }
      ]
    },
    {
      title: 'Offline Payments',
      icon: FolderIcon,
      isDropdown: true,
      id: 'offlinepayments',
      completed: false,
      subItems: [
        {
          title: 'Make Offline Payment',
          icon: AssignmentIcon,
          path: '/main/accounts/offline-payment-form',
          completed: false,
          id: 'offline-payment-form'
        },
        {
          title: 'Offline Payment Details',
          icon: ListIcon,
          path: '/main/accounts/offline-payment-details',
          completed: false,
          id: 'offline-payment-details'
        },
      ]
    },
    {
      title: 'View Invoices',
      icon: InvoiceIcon,
      isDropdown: true,
      id: 'invoice',
      completed: false,
      subItems: [
        {
          title: 'Unpaid Invoice',
          icon: InvoiceIcon,
          path: '/main/accounts/unpaid-invoice',
          completed: false,
          id: 'unpaid-invoice'
        },
        {
          title: 'Proforma Invoice',
          icon: InvoiceIcon,
          path: '/main/accounts/proforma-invoice',
          completed: false,
          id: 'proforma-invoice'
        },
        {
          title: 'Generated Application/Assessment Invoice',
          icon: InvoiceIcon,
          path: '/main/accounts/generated-invoice',
          completed: false,
          id: 'generated-invoice'
        },
        {
          title: 'Generated AAFEE Invoice',
          icon: InvoiceIcon,
          path: '/main/accounts/generatedaafee-invoice',
          completed: false,
          id: 'generatedaafee-invoice'
        },
        {
          title: 'AAFEE Proforma Invoice',
          icon: InvoiceIcon,
          path: '/main/accounts/aafeeproforma-invoices',
          completed: false,
          id: 'proformaaafee-invoice'
        },
      ]
    },

    // {
    //   title: 'AA Fee Invoice Generate',
    //   icon: ReceiptIcon,
    //   path: '/main/accounts/aafee-invoice-generate',
    //   completed: false,
    //   id: 'aafee-invoice-generate'
    // },
    {
      title: 'Exemptions',
      icon: VerifiedIcon,
      isDropdown: true,
      id: 'exemptions',
      completed: false,
      subItems: [
        {
          title: 'GST Exemption',
          icon: GSTIcon,
          path: '/main/accounts/gst-exemption',
          completed: false,
          id: 'gst-exemption'
        },
        {
          title: 'SEZ Exemption',
          icon: ExemptionIcon,
          path: '/main/accounts/sez-exemption',
          completed: false,
          id: 'sez-exemption'
        },
        {
          title: 'SEZ Applications',
          icon: AssignmentIcon,
          path: '/main/accounts/sez-applications',
          completed: false,
          id: 'sez-applications'
        }
      ]
    },
    {
      title: 'Laboratory Search',
      icon: SearchIcon,
      path: '/main/laboratory-search',
      completed: false,
      id: 'laboratory-search'
    },
    {
      title: 'Data Download',
      icon: AnalyticsIcon,
      path: '/main/accounts/download',
      completed: false,
      id: 'accounts-download'
    },
     {
      title: 'Invoice Data Pushed',
      icon: DescriptionIcon,
      path: '/main/accounts/invoice-data-pushed',
      completed: false,
      id: 'invoice-data'
    },
    {
      title: 'Accounts Section',
      icon: AccountBalanceIcon,
      path: '/main/accounts/outstanding-ledger',
      completed: false,
      id: 'outstanding-ledger'
    },
    // {
    //   title: 'Transaction Report',
    //   icon: AnalyticsIcon,
    //   path: '/main/accounts/transaction-report',
    //   completed: false,
    //   id: 'transaction-report'
    // },
    // {
    //   title: 'Invoice Management',
    //   icon: ReceiptIcon,
    //   path: '/main/accounts/invoice-management',
    //   completed: false,
    //   id: 'invoice-management'
    // },
   
  ];

  const handleSectionClick = (item, index) => {
    // Get current lab type from localStorage
    const labTypeId = localStorage.getItem('labTypeId') || '2';

    console.log('Sidebar - navigating to:', item.path, 'with labTypeId:', labTypeId);

    // Check if it's an external URL
    if (item.path.startsWith('http://') || item.path.startsWith('https://')) {
      // For external URLs, use window.location.href
      window.location.href = item.path;
    } else {
      // For internal routes, use React Router navigate
      navigate(item.path);
    }

    // Close mobile drawer if open
    if (isMobile) {
      onClose();
    }
  };

  return (
    <>
      <Box sx={{
        p: 2,
        borderBottom: '1px solid #e0e0e0',
        transition: 'all 0.3s ease-in-out',
        backgroundColor: isSubUser ? '#e3f2fd' : 'transparent', // Highlight for sub-users
      }}>
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          transition: 'all 0.3s ease-in-out'
        }}>
          {!collapsed ? (
            <Box sx={{
              opacity: collapsed ? 0 : 1,
              transition: 'opacity 0.3s ease-in-out',
              flexGrow: 1,
            }}>
              <Typography variant="h6" sx={{
                fontWeight: 600,
                color: '#00024c',
                transition: 'all 0.3s ease-in-out',
              }}>
                Accounts Dashboard
              </Typography>
            </Box>
          ) : (
            <Box sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              transition: 'all 0.3s ease-in-out',
            }}>
              {/* <DashboardIcon sx={{ 
                color: '#00024c', 
                fontSize: 28,
                transition: 'all 0.3s ease-in-out',
              }} /> */}
            </Box>
          )}

          {/* Collapse/Expand Button for Desktop */}
          {!isMobile && (
            <IconButton
              onClick={onCollapseToggle}
              sx={{
                color: '#fafafaff',
                backgroundColor: '#1959b9ff',
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                  backgroundColor: '#1959b934',
                  color: '#ffffffff',
                },
              }}
            >
              {collapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          )}

          {/* Close Button for Mobile */}
          {isMobile && (
            <IconButton
              onClick={onClose}
              sx={{ color: '#00024c' }}
            >
              <CloseIcon />
            </IconButton>
          )}
        </Box>
      </Box>

      {/* medical Navigation Items */}
      <Box sx={{
        p: collapsed ? 1 : 2,
        borderBottom: '1px solid #e0e0e0',
        flexGrow: 1,
        overflowY: 'auto',
        transition: 'padding 0.3s ease-in-out'
      }}>
        <List sx={{ p: 0 }}>
          {MenuItems.filter(item => {
            // If user is a sub-user, only show Discipline and Proficiency Testing
            if (isSubUser) {
              return item.id === 'discipline' || item.id === 'proficiency-testing';
            }

            // For regular users, apply existing conditional logic
            if (!item.conditional) return true;
            if (item.requiresStage18UserType4) return shouldShowFinalSubmitOptions;
            if (item.requiresStage18a) return shouldShowFinaluserSubmitOptions;
            return showDeclaration;
          }).map((item, index) => {
            // Handle dropdown menu items
            if (item.isDropdown) {
              const hasActiveSubItem = item.subItems?.some(subItem => location.pathname === subItem.path);
              const isOpen = openDropdowns[item.id] || false;

              return (
                <React.Fragment key={index}>
                  <ListItem disablePadding sx={{ mb: 0.5 }}>
                    <ListItemButton
                      onClick={() => setOpenDropdowns(prev => ({ ...prev, [item.id]: !prev[item.id] }))}
                      sx={{
                        borderRadius: 1,
                        justifyContent: collapsed ? 'center' : 'flex-start',
                        px: collapsed ? 1 : 2,
                        transition: 'all 0.3s ease-in-out',
                        '&:hover': {
                          backgroundColor: '#f5f5f5',
                          transform: 'translateX(2px)',
                        },
                        backgroundColor: hasActiveSubItem ? '#e3f2fd' : 'transparent',
                        py: 1,
                      }}
                    >
                      <ListItemIcon sx={{
                        minWidth: collapsed ? 'unset' : 35,
                        justifyContent: 'center',
                        transition: 'all 0.3s ease-in-out',
                      }}>
                        <item.icon sx={{
                          fontSize: collapsed ? 24 : 18,
                          color: hasActiveSubItem ? '#1976d2' : '#666',
                          transition: 'all 0.3s ease-in-out',
                        }} />
                      </ListItemIcon>
                      {!collapsed && (
                        <>
                          <ListItemText
                            primary={item.title}
                            sx={{
                              opacity: collapsed ? 0 : 1,
                              transition: 'opacity 0.3s ease-in-out',
                              '& .MuiListItemText-primary': {
                                fontSize: '0.8rem',
                                fontWeight: hasActiveSubItem ? 600 : 500,
                                color: hasActiveSubItem ? '#1976d2' : 'text.primary',
                                transition: 'all 0.3s ease-in-out',
                              },
                            }}
                          />
                          {isOpen ? <ExpandLess /> : <ExpandMore />}
                        </>
                      )}
                    </ListItemButton>
                  </ListItem>

                  {/* Submenu Items */}
                  {!collapsed && (
                    <Collapse in={isOpen} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        {item.subItems?.map((subItem, subIndex) => {
                          const isSubActive = location.pathname === subItem.path;
                          return (
                            <ListItem key={subIndex} disablePadding sx={{ mb: 0.5 }}>
                              <ListItemButton
                                onClick={() => handleSectionClick(subItem, subIndex)}
                                selected={isSubActive}
                                sx={{
                                  borderRadius: 1,
                                  pl: 4,
                                  transition: 'all 0.3s ease-in-out',
                                  '&:hover': {
                                    backgroundColor: '#f5f5f5',
                                    transform: 'translateX(2px)',
                                  },
                                  '&.Mui-selected': {
                                    backgroundColor: '#e3f2fd',
                                    '&:hover': {
                                      backgroundColor: '#bbdefb',
                                    },
                                  },
                                  py: 0.75,
                                }}
                              >
                                <ListItemIcon sx={{
                                  minWidth: 35,
                                  transition: 'all 0.3s ease-in-out',
                                }}>
                                  <subItem.icon sx={{
                                    fontSize: 16,
                                    color: subItem.completed ? '#4caf50' : isSubActive ? '#1976d2' : '#666',
                                    transition: 'all 0.3s ease-in-out',
                                  }} />
                                </ListItemIcon>
                                <ListItemText
                                  primary={subItem.title}
                                  sx={{
                                    '& .MuiListItemText-primary': {
                                      fontSize: '0.75rem',
                                      fontWeight: isSubActive ? 600 : 400,
                                      color: isSubActive ? '#1976d2' : 'text.primary',
                                      transition: 'all 0.3s ease-in-out',
                                    },
                                  }}
                                />
                                {subItem.completed && (
                                  <VerifiedIcon sx={{
                                    color: '#4caf50',
                                    fontSize: 14,
                                  }} />
                                )}
                              </ListItemButton>
                            </ListItem>
                          );
                        })}
                      </List>
                    </Collapse>
                  )}
                </React.Fragment>
              );
            }

            // Handle regular menu items
            const isActive = location.pathname === item.path;
            const listItemContent = (
              <ListItemButton
                onClick={() => handleSectionClick(item, index)}
                selected={isActive}
                sx={{
                  borderRadius: 1,
                  justifyContent: collapsed ? 'center' : 'flex-start',
                  px: collapsed ? 1 : 2,
                  transition: 'all 0.3s ease-in-out',
                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                    transform: 'translateX(2px)',
                  },
                  '&.Mui-selected': {
                    backgroundColor: '#e3f2fd',
                    '&:hover': {
                      backgroundColor: '#bbdefb',
                    },
                  },
                  py: 1,
                }}
              >
                <ListItemIcon sx={{
                  minWidth: collapsed ? 'unset' : 35,
                  justifyContent: 'center',
                  transition: 'all 0.3s ease-in-out',
                }}>
                  <item.icon sx={{
                    fontSize: collapsed ? 24 : 18,
                    color: item.completed ? '#4caf50' : isActive ? '#1976d2' : '#666',
                    transition: 'all 0.3s ease-in-out',
                  }} />
                </ListItemIcon>
                {!collapsed && (
                  <>
                    <ListItemText
                      primary={item.title}
                      sx={{
                        opacity: collapsed ? 0 : 1,
                        transition: 'opacity 0.3s ease-in-out',
                        '& .MuiListItemText-primary': {
                          fontSize: '0.8rem',
                          fontWeight: isActive ? 600 : 500,
                          color: isActive ? '#1976d2' : 'text.primary',
                          transition: 'all 0.3s ease-in-out',
                        },
                      }}
                    />
                    {item.completed && (
                      <VerifiedIcon sx={{
                        color: '#4caf50',
                        fontSize: 16,
                        opacity: collapsed ? 0 : 1,
                        transition: 'opacity 0.3s ease-in-out',
                      }} />
                    )}
                  </>
                )}
              </ListItemButton>
            );

            return (
              <ListItem key={index} disablePadding sx={{ mb: 0.5 }}>
                {collapsed ? (
                  <Tooltip title={item.title} placement="right" arrow>
                    {listItemContent}
                  </Tooltip>
                ) : (
                  listItemContent
                )}
              </ListItem>
            );
          })}
        </List>
      </Box>

    </>
  );
};

export default Sidebar;
